<top-bar (onChangeLanguage)="changeLanguage($event)"></top-bar>
<auth-flow [authState$]="authState$"></auth-flow>
<div id="main">
    <section (onChangeLanguage)="changeLanguage($event)" class="col-md-2 main-section close-movil sidebar-filters sidebar-flex" [ngClass]="{'open': showSideFilters}">
        <side-filters></side-filters>
        <company-info></company-info>
        <div class="row copyright">
            <span>Powered by <a href="http://www.idstone.es/" target="_blank">IDStone</a></span>
        </div>
    </section>
    <section class="col-md-10 col-sm-12 main-section" [scrollWindow]="false" infinite-scroll (scrolled)="emitScrollEvent()">
        <div class="stage">
            <search-filters-bar></search-filters-bar>
            <router-outlet></router-outlet>
        </div>
    </section>
</div>